module.exports = __webpack_public_path__ + "img/ic_float_pre.bd5ef9bf.svg";